import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { GripVertical, Trash2 } from 'lucide-react'
import { BlockRenderer } from '../website-blocks'
import type { WebsiteBlock } from '../../types'
import { useI18n } from '../../i18n'

interface SortableBlockProps {
  block: WebsiteBlock
  isEditing: boolean
  isSelected: boolean
  onSelect: (id: string) => void
  onDelete: (blockId: string) => void
}

export default function SortableBlock({ block, isEditing, isSelected, onSelect, onDelete }: SortableBlockProps) {
  const { t } = useI18n()
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: block.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={style}
      className={`group relative ${isDragging ? 'opacity-50 z-50' : ''} ${isSelected ? 'ring-2 ring-blue-500 ring-offset-1' : ''}`}
      onClick={(e) => { e.stopPropagation(); onSelect(block.id) }}>

      {/* Hover overlay with drag handle + delete */}
      {isEditing && (
        <div className="absolute top-2 right-2 z-10 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            {...attributes}
            {...listeners}
            className="p-1.5 rounded-md bg-white/90 shadow-sm border border-gray-200 text-gray-400 hover:text-gray-600 cursor-grab active:cursor-grabbing"
            title={t('拖拽排序', 'Drag to reorder')}>
            <GripVertical className="h-3.5 w-3.5" />
          </button>
          <button
            className="p-1.5 rounded-md bg-white/90 shadow-sm border border-gray-200 text-gray-400 hover:text-red-500"
            title={t('删除区块', 'Delete block')}
            onClick={(e) => { e.stopPropagation(); onDelete(block.id) }}>
            <Trash2 className="h-3.5 w-3.5" />
          </button>
        </div>
      )}

      <BlockRenderer block={block} isEditing={isEditing} isSelected={isSelected} onSelect={onSelect} />
    </div>
  )
}
